export function logout(noRedirect?: boolean) {
  window.dispatchEvent(new CustomEvent('logout', { detail: { noRedirect } }));
}

export function onLogout(callback: (noRedirect?: boolean) => void) {
  window.addEventListener('logout', (e) => {
    callback((e as CustomEvent).detail.noRedirect);
  });
}
